import { RadioCard } from "@blurb/codex-react";
import { RpiLabelText } from "@rpi/openapi-core";
import { getDisplayName } from "./attributeValueMappings";

// Configuration for Text cards
export type TextCardProps = {
  value: string;
  displayName: string;
};

export const defaultGetTextCardConfig =
  (attributeKey: string): ((value: string) => TextCardProps | undefined) =>
  (value) => {
    if (!attributeKey) return undefined;

    const displayName = getDisplayName(attributeKey, String(value));

    if (!displayName) return undefined;

    return {
      value: String(value),
      displayName,
    };
  };

export const TextCard = ({ value, displayName }: TextCardProps) => {
  return (
    <RadioCard value={value} data-testid={value}>
      <RpiLabelText>{displayName}</RpiLabelText>
    </RadioCard>
  );
};
